/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseManagementAccessResponse } from '../../models/base-management-access-response';

export interface GetBaseManagementAccess$Params {
}

export function getBaseManagementAccess(http: HttpClient, rootUrl: string, params?: GetBaseManagementAccess$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseManagementAccessResponse>> {
  const rb = new RequestBuilder(rootUrl, getBaseManagementAccess.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseManagementAccessResponse>;
    })
  );
}

getBaseManagementAccess.PATH = '/api/scheduler/bases/access';
